<template>

   <div class="main-content-container  container-fluid">

        <div class="page-header row no-gutters py-4  mb-4">
            <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
                <span class="text-uppercase page-subtitle">{{$t("REPORTS.SILO_DETAILS")}}</span>
            </div>
        </div>

        <w-card size="100">
            <div class="row mb-2"  v-loading="loadingSilos">
                <div class="col-12 col-lg-6 text-lg-left text-center ">
                    <h5 class="font-weight-bold">{{siteName}}</h5>
                </div>

               <div class="col-12 col-lg-6 text-lg-right text-center">
                   <p class="mb-2 mb-lg-0">{{$t("REPORTS.STATUS_COLOR")}} </p>
                   <el-switch
                     v-model="siloColor" 
                     align="center">
                   </el-switch>
               </div>

            </div>
            <hr>
            
            <el-row style="height: 100px" v-if="loadingSilos" v-loading="loadingSilos"/>
            
            
            <div class="row" v-if="!loadingSilos" >
               <div class="col-12  mb-4">
                    <div class="d-flex align-items-center">
                        <h5>{{silo.name}}</h5>
                        <h6 class="text-muted ml-2 text-capitalize">({{$t('GRAIN.' + silo.type.toUpperCase()) }}) </h6>
                    </div>    
                    <div class="d-flex align-items-center">

                        <h6> {{$t("REPORTS.BAGGED_DATE")}} 
                            <span v-if="silo.baggedate === '1999-12-31 23:59:59'"> - </span> 
                            <span v-else class = "font-weight-bold">{{formatDate(silo.baggedate)}}  </span> 
                            | 
                            {{$t("REPORTS.INI_MOISTURE")}}
                            <span v-if="silo.initmoisture === '0'"> - </span> 
                            <span v-else class = "font-weight-bold">{{silo.initmoisture}}%</span> 
                            | 
                            {{$t("REPORTS.TONS")}}
                            <span v-if="silo.tons === '0'"> - </span>   
                            <span v-else class = "font-weight-bold">{{silo.tons}}</span>
                        </h6>                    
                    </div>
                
                    <div v-if="siloDetails">
                    <siloImg :id="silo.id" :siteId="selectedSiteId"
                        :date="new Date(date)" :silo-name="silo.name" :siloColor="siloColor"/>   
                    </div> 
                    <div v-else>
                        <entireSiloImg :id="silo.id" :siteId="selectedSiteId"
                             :date="new Date(date)" :silo-name="silo.nombre" :siloColor="siloColor" 
                             :siteName="siteName" :siloType="silo.type" />
                    </div>
                
               </div>
            </div>
            
            <div class="row mt-md-4 mt-4">
                <div class="col-12 text-right">
                    <el-button type="primary" @click="backToDashboard()">{{$t("COMMON.BACK_DASHBOARD")}}</el-button>
                </div>
            </div>

        </w-card>
    </div>

</template>

<script>
    import wCard from "../components/common/wCard";
    import SiloMetricsChart from "../components/common/charts/SiloMetricsChart"
    import api from "../utils/api/api.js"
    import siloImg from "../components/common/siloImg";
    import entireSiloImg from "../components/common/entireSiloImg"
    //import siloImg from "../components/common/entireSiloImg";
    import dateFormater from "../utils/dateFormater";
    import routesNames from "../utils/router/routesNames";

    export default {
        name: "OnlySiloView",
        components: {
            "w-card": wCard,
            "silo-metrics-chart": SiloMetricsChart,
            "siloImg": siloImg,
            "entireSiloImg" :entireSiloImg 
        },
        data: function () {
            return {
                date: (new Date()).toDateString(),
                selectedSiteId: undefined,
                selectedSiloId: undefined,
                silo: undefined,
                siteName: undefined,
                sections: [],
                loadingSilos: true,
                //siteHasSilo: true,
                siloColor: true,
                siloDetails: this.$store.state.viewDetails
            }
        },
        computed: {
            loadingSites: function () {
                return this.sites.length === 0 && this.userHasSites;
            },
        },
        watch: {
            siloColor: function()
            {

            },
            date(newDate) {
                console.info("Nueva fecha ", newDate);
            }
        },
        methods: {
            formatDate(date) {
                return dateFormater.onlyDateFormat(date,this.$store.state.language);
            },
            backToDashboard()
            {
                this.$router.push({name: routesNames.DASHBOARD});
            }
        },
        mounted() {
            this.loadingSilos = true;
            this.selectedSiteId = this.$store.state.siteSelected;            
            this.selectedSiloId = this.$store.state.siloSelected;

            api.getSilo(this.selectedSiteId, this.selectedSiloId).then( value => {
                this.siteName = value.sitename;
                this.silo = value.silo;
                this.loadingSilos = false;
            });

            //console.log(this.silo);
        }

    }
</script>

<style>

</style>